module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"mergeFields":{"recipient":"Recipient","contactFirstName":"Contact\u0027s first name"},"mergeFieldFeedbackLink":"What other fields would be helpful?","mergeFieldTooltip":"Add a merge field to personalize your text message"}}')
  delete Component.options._Ctor
}
